<template>
    <BaseModal
        :id="'static-info-rooms'"
        :title="title"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form @submit.prevent="closeModal()">
                <div class="tab-pane fade active show mt-4" id="listation" v-if="rooms.length">
                    <div class="row mb-0 no-gutters">
                        <div class="col-lg-12">
                            <v-card>
                                <DinamicTable
                                    :headers="room_table_headers"
                                    :search="''" 
                                    :items="rooms"
                                    :selectable_columns="false"
                                    :size="30"
                                />
                            </v-card>
                        </div>
                    </div>
                </div>
            <CentralLiteButtons :save_text="'Done'"/>
            </form>
        </template>
    </BaseModal>
            
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'
import DinamicTable         from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }        from    'notyf'
import 'notyf/notyf.min.css'; // for React and Vue\
import Resources from './resources'

const notyf = new Notyf({
    duration: 8000,
})

export default {
    props: 
    [
        'rest_api',
        'breadcrumb',
        'form_data'
    ],

    name: 'InfoRooms',

    components: {
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
        DinamicTable,
    },

    data()
    {
        return {
            notyf,
            title: '',
            daily_assignment: {},
            room_table_headers: Resources.room_table_headers,
            rooms: [],
            message: ''
        }
    },

    methods: 
    {
        closeModal()
        {
            window.$(`#static-info-rooms`).modal('hide');
        },

        initialSetup(daily_assignment, header)
        {
            this.daily_assignment = daily_assignment
            this.rooms = []

            this.room_table_headers = Resources.room_table_headers

            if(header == 'total_rooms_cleaned_record')
            {
                this.title = `Cleaned Rooms - ${daily_assignment.description}`
                this.message = 'You can see the rooms that have been cleaned by the associates in this daily assignment'
                this.room_table_headers = Resources.room_table_headers_2
                this.getCleanedRooms()
            }
            else if(header == 'total_rooms_not_cleaned_record')
            {
                this.room_table_headers = Resources.room_table_headers_2
                this.title = `Rooms left to clean - ${daily_assignment.description}`
                this.message = 'You can see the rooms that have not been cleaned yet in this daily assignment'
                this.getUncleanedRooms()
            }
            else if(header == 'total_rooms_not_cleaned')
            {
                this.title = `Rooms left to clean - All Daily Assignments`
                this.message = 'You can see all the rooms that have not been cleaned yet'
                this.getAllUncleanedRooms()
            }
            else if(header == 'total_rooms_cleaned')
            {
                this.title = `Cleaned Rooms - All Daily Assignments`
                this.message = 'You can see all the rooms that have been cleaned by the associates'
                this.getAllCleanedRooms()
            }
        },

        async getCleanedRooms()
        {
            let url = `${this.rest_api}/cleaned_rooms/${this.daily_assignment.id}?`
            url += this.form_data.current_date !=  this.currentDateToString() ? `date=${this.form_data.current_date}` : ''

            const res = await this.get(`${url}`)

            if(res.status)
            {
                this.rooms = res.data.cleaned_rooms
            }
            else
            {
                this.error_handling(res)
            }
        },

        async getUncleanedRooms()
        {
            let url = `${this.rest_api}/uncleaned_rooms/${this.daily_assignment.id}`
            url += this.form_data.current_date !=  this.currentDateToString() ? `?date=${this.form_data.current_date}` : ''

            const res = await this.get(`${url}`)

            if(res.status)
            {
                this.rooms = res.data.uncleaned_rooms
            }
            else
            {
                this.error_handling(res)
            }
        },

        async getAllUncleanedRooms()
        {
            let url = `${this.rest_api}/all/uncleaned_rooms?`
            url += this.form_data.current_date !=  this.currentDateToString() ? `date=${this.form_data.current_date}&` : ''
            url += this.form_data.supervisor_id  ? `supervisor_id=${this.form_data.supervisor_id}&` : ''
            url += this.form_data.shift_id  ? `shift_id=${this.form_data.shift_id}` : ''

            const res = await this.get(`${url}`)

            if(res.status)
            {
                this.rooms = res.data.all_uncleaned_rooms
            }
            else
            {
                this.error_handling(res)
            }
        },

        async getAllCleanedRooms()
        {
            let url = `${this.rest_api}/all/cleaned_rooms?`
            url += this.form_data.current_date !=  this.currentDateToString() ? `date=${this.form_data.current_date}&` : ''
            url += this.form_data.supervisor_id  ? `supervisor_id=${this.form_data.supervisor_id}&` : ''
            url += this.form_data.shift_id  ? `shift_id=${this.form_data.shift_id}` : ''
            const res = await this.get(`${url}`)

            if(res.status)
            {
                this.rooms = res.data.all_cleaned_rooms
            }
            else
            {
                this.error_handling(res)
            }
        }
    },

   
}
</script>